import ReportSettingsSection from "./ReportSettingsSection";
import SeniorManagerReportPreviewDrawer from "./SeniorManagerReportPreviewDrawer";
import {
  useGetSeniorManagerSettingsQuery,
  useGetSeniorManagerPreviewQuery,
  useUpdateSeniorManagerSettingsMutation,
} from "./weeklyCheckInReportSettingsApi";

const SeniorManagerReportSettingsSection = () => {
  const { data: settings, isLoading, isError } =
    useGetSeniorManagerSettingsQuery();
  const { data: preview, isLoading: isPreviewLoading } =
    useGetSeniorManagerPreviewQuery();
  const [updateSettings, { isLoading: isSaving }] =
    useUpdateSeniorManagerSettingsMutation();

  return (
    <ReportSettingsSection
      settings={settings}
      isLoading={isLoading}
      isError={isError}
      preview={preview}
      isPreviewLoading={isPreviewLoading}
      isSaving={isSaving}
      updateSettings={updateSettings}
      reportName="Senior Manager Check-in Report"
      thresholdCopyText="of their span is invited to check-ins"
      PreviewDrawer={SeniorManagerReportPreviewDrawer}
    />
  );
};

export default SeniorManagerReportSettingsSection;
